import { FlexHttpError } from '../models/flexHttpError.mjs';

const isFlexHttpError = (error) => {
  return error instanceof Error && "code" in error && "message" in error;
};
const toFlexHttpError = (errorDto) => {
  if (typeof errorDto === "string") {
    const isErrorMessageVeryHTMLLike = errorDto.trim().startsWith("<") && errorDto.length > 100;
    return new FlexHttpError(
      "UNKNOWN_ERROR",
      isErrorMessageVeryHTMLLike ? `Unknown HTML error (${errorDto.slice(0, 100)}...)` : errorDto,
      400
    );
  }
  if (typeof errorDto !== "object" && !(errorDto instanceof Error)) {
    throw new Error("errorDto is not an object nor an error instance");
  }
  try {
    const {
      code,
      message,
      status = 900,
      title,
      trace
    } = errorDto;
    return new FlexHttpError(code, message, status, title, trace);
  } catch (e) {
    throw new Error("errorDto is not a FlexHttpError");
  }
};

export { isFlexHttpError, toFlexHttpError };
//# sourceMappingURL=flexHttpError.mjs.map
